import { CreateBalanceForm } from "Partner/Components/Form/CreateBalanceForm";
import { BaseCard } from "Shared/Components/Cards/BaseCard";
import type { FC } from "react";

type CreateBalanceWidgetProps = {
	partnerId: number;
};

export const PartnerCreateBalanceWidget: FC<CreateBalanceWidgetProps> = ({
	partnerId,
}) => {
	return (
		<BaseCard title="Create Balance">
			<CreateBalanceForm partnerId={partnerId} />
		</BaseCard>
	);
};
